import { render, staticRenderFns } from "./StoreDetached.vue?vue&type=template&id=3fe609de&scoped=true"
import script from "./StoreDetached.vue?vue&type=script&lang=js"
export * from "./StoreDetached.vue?vue&type=script&lang=js"
import style0 from "./StoreDetached.vue?vue&type=style&index=0&id=3fe609de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe609de",
  null
  
)

export default component.exports